<template>
    <div class="share-box">
        <p>share</p>
        <a class="line" :href="'https://social-plugins.line.me/lineit/share?url=' + href"><i></i></a>
        <a class="fb"  target="_blank" 
        :href="'https://www.facebook.com/sharer/sharer.php?u='+href"><i></i></a>
    </div>
</template>
<script>

export default {
    name: 'Socialmedia',
    data () {
        return {
            href:''
        }
    },
    mounted () {
        this.href = window.location.href;
    },
    created(){
    },
    methods: {
    }
}
</script>


// WEBPACK FOOTER //
// src/components/index/shared/Socialmedia.vue